import React, { useState } from "react";
import {
  Box,
  TextField,
  IconButton,
  Typography,
  CircularProgress,
  makeStyles,
} from "@material-ui/core";
import SendIcon from "@material-ui/icons/Send";

const MAX_LEN = 255;

const useStyles = makeStyles((theme) => ({
  wrap: {
    borderTop: "1px solid #e0e0e0",
    padding: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    backgroundColor: "#fff",
  },
  input: {
    flex: 1,
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
    },
  },
  send: {
    color: "#ec6535",
  },
  meta: {
    position: "absolute",
    bottom: 4,
    right: 56,
    fontSize: "0.7rem",
    color: "#888",
  },
}));

export default function ChatComposer({ disabled, sending, onSend }) {
  const classes = useStyles();
  const [text, setText] = useState("");

  const trimmed = text.trim();
  const canSend = !disabled && !sending && trimmed.length > 0;

  const handleSend = () => {
    if (!canSend) return;
    onSend(trimmed.slice(0, MAX_LEN));
    setText("");
  };

  const onKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleSend();
    }
  };

  return (
    <Box className={classes.wrap} style={{ position: "relative" }}>
      <TextField
        className={classes.input}
        multiline
        maxRows={4}
        size="small"
        variant="outlined"
        placeholder={
          disabled ? "Load forecasts first" : "Type your comment here..."
        }
        value={text}
        onChange={(e) => setText(e.target.value.slice(0, MAX_LEN))}
        onKeyDown={onKeyDown}
        disabled={disabled || sending}
      />
      <IconButton
        className={classes.send}
        onClick={handleSend}
        disabled={!canSend}
      >
        {sending ? <CircularProgress size={18} /> : <SendIcon />}
      </IconButton>
      {text.length > 200 && (
        <Typography className={classes.meta}>
          {text.length}/{MAX_LEN}
        </Typography>
      )}
    </Box>
  );
}
